'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Service tab - Grid
 */
var FlightServiceClassGridTransformerFactory = function FlightServiceClassGridTransformerFactory($filter, $window, DataTransformer, bookingsIntakeTransformationService, mergeScenarioDataService, effectiveValueService, configurationService, momentService, hepService, flightLiveDataService, classIndicesService, fcrService, bookingsTrendCorrectionTransformationService, renormalizeEffectiveValueService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getTimeOfDaySize() {
    return configurationService.getTimeOfDayBucketSize();
  }
  function getTimeOfDayOfMoment(moment) {
    moment = moment.clone();
    var bucket = moment.hours() - moment.hours() % getTimeOfDaySize();
    return [moment.hours(bucket).minutes(0).format('HH:mm'), moment.hours(Math.min(24, bucket + getTimeOfDaySize())).minutes(0).subtract(1, 'minutes').format('HH:mm')].join('-');
  }
  function getTimeOfMoment(moment) {
    moment = moment.clone();
    var dateString = rmMomentFormat(momentService.now(momentService.FIELD.DEPARTURE_DATE), 'DATE_ISO') + 'T' + moment.format('HH:mm');
    return momentService.of(dateString, momentService.FIELD.DEPARTURE_DATE);
  }
  function FlightServiceClassGridTransformer() {
    this.sourceType = 'service';
    this.targetType = 'service-flight-analysis';
    this.priority = 1;
  }
  FlightServiceClassGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightServiceClassGridTransformer.constructor = FlightServiceClassGridTransformer;
  FlightServiceClassGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  FlightServiceClassGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightServiceClassGridTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      flightLiveDataService.setLastRefreshTime('service-flight-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  FlightServiceClassGridTransformer.prototype.transform = function (data) {
    setLastRefreshTime(data.domain.timeStamp);
    var memoizedClassGroupIndices = _.memoize(classIndicesService.prepareClassGroupIndices);
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var memoizedDOWOfMoment = _.memoize(getDOWOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedTimeOfDayOfMoment = _.memoize(getTimeOfDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedGetTimeOfMoment = _.memoize(getTimeOfMoment, function (moment) {
      return moment.valueOf();
    });
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    var isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
    function setEffectiveValues(result, entry) {
      if (!isDemandDistributionIncremental) {
        var effective = effectiveValueService.calculateAll(entry, 'service-demand-analysis');
        _.assign(result, effective);
      } else {
        result.effectiveRegularRemainingDemandFC = entry.regularRemainingDemandAdjustedFC === undefined ? entry.regularRemainingDemandFC : entry.regularRemainingDemandAdjustedFC;
        result.effectiveMappedRemainingDemandFC = entry.mappedRemainingDemandAdjustedFC === undefined ? entry.mappedRemainingDemandFC : entry.mappedRemainingDemandAdjustedFC;
        result.effectiveRegularAggregateShare = entry.regularEffShare;
        result.effectiveMappedAggregateShare = entry.mappedEffShare;
      }
    }
    var transformData = function transformData(serviceClasses) {
      var result = [];
      if (!serviceClasses || !serviceClasses.length) {
        return;
      }
      for (var i = 0, length = serviceClasses.length; i < length; i++) {
        var entry = serviceClasses[i];
        var entryKey = entry.serviceId + entry.carrier + entry.market + entry.significantPOS + entry.classGroup + entry.className + entry.departureDate;
        var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var momentEventTimeStamp = memoizedMomentOfEventDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var curDOW = memoizedDOWOfMoment(momentDepartureDate);
        var curYMD = memoizedYearMonthDayOfMoment(momentDepartureDate);
        var isAuthOverride = entry.userRegularHardOverrideType === 'AUTH';
        var isAvailOverride = entry.userRegularHardOverrideType === 'AVAIL';
        var isManuallyControlled = _.isNil(entry.userRegularIsManuallyControlled) ? entry.isManuallyControlled ? 'Yes' : 'No' : entry.userRegularIsManuallyControlled === 'true' ? 'Yes' : 'No';
        var newEntry = {
          entryKey: entryKey,
          scenarioName: entry.scenarioName,
          carrier: entry.carrier,
          market: entry.market,
          origin: entry.origin,
          destination: entry.destination,
          route: entry.route,
          posName: entry.significantPOS,
          //added for POS
          numberOfStops: entry.numberOfStops,
          //added for numberOfStops
          classGroup: entry.classGroup,
          classGroupIndex: memoizedClassGroupIndices(fcrService.getClassGroupIndicesKey(momentDepartureDate, entry.market))[entry.classGroup],
          className: entry.className,
          relativeValue: entry.relativeValue,
          significantPOS: entry.significantPOS,
          elapsedTime: entry.elapsedTime,
          criticality: entry.criticality,
          serviceId: entry.serviceId,
          referenceCurveServiceId: entry.referenceCurveServiceId,
          serviceClassId: entry.serviceClassId,
          mappedTripBooking: entry.mappedTripBookings,
          regularTripBooking: entry.regularTripBookings,
          fare: entry.fare,
          proratedFare: entry.proratedFare,
          mappedFare: entry.mappedFare,
          mappedProratedFare: entry.mappedProratedFare,
          regularReservationHoldingsTotal: entry.regularReservationHoldingsTotal,
          regularReservationHoldingsIdv: entry.regularReservationHoldingsIdv,
          regularReservationHoldingsGroup: entry.regularReservationHoldingsGroup,
          regularExpectedBookings: entry.regularExpectedBookings,
          mappedReservationHoldingsTotal: entry.mappedReservationHoldingsTotal,
          mappedReservationHoldingsIdv: entry.mappedReservationHoldingsIdv,
          mappedReservationHoldingsGroup: entry.mappedReservationHoldingsGroup,
          mappedExpectedBookings: entry.mappedExpectedBookings,
          regularRevenueTotal: entry.regularRevenueTotal,
          regularRevenueExpectedTotal: entry.regularRevenueExpectedTotal,
          mappedRevenueTotal: entry.mappedRevenueTotal,
          mappedRevenueExpectedTotal: entry.mappedRevenueExpectedTotal,
          regularRemainingDemandFC: entry.regularRemainingDemandFC,
          userTypeRegularRemainingDemandFC: entry.userTypeRegularRemainingDemandFC,
          userValueRegularRemainingDemandFC: entry.userValueRegularRemainingDemandFC,
          effectiveRegularRemainingDemandFC: entry.effectiveRegularRemainingDemandFC,
          regularRemainingDemandFCCV: entry.regularRemainingDemandFCCV,
          regularRemainingDemandMWTP: entry.regularRemainingDemandMWTP,
          regularRemainingDemandMWTPCV: entry.regularRemainingDemandMWTPCV,
          regularRemainingDemandPreBTC: entry.regularRemainingDemandPreBTC,
          regularSellupRate: entry.regularSellupRate,
          mappedRemainingDemandFC: entry.mappedRemainingDemandFC,
          userTypeMappedRemainingDemandFC: entry.userTypeMappedRemainingDemandFC,
          userValueMappedRemainingDemandFC: entry.userValueMappedRemainingDemandFC,
          effectiveMappedRemainingDemandFC: entry.effectiveMappedRemainingDemandFC,
          mappedRemainingDemandFCCV: entry.mappedRemainingDemandFCCV,
          mappedRemainingDemandMWTP: entry.mappedRemainingDemandMWTP,
          mappedRemainingDemandMWTPCV: entry.mappedRemainingDemandMWTPCV,
          mappedRemainingDemandPreBTC: entry.mappedRemainingDemandPreBTC,
          mappedSellupRate: entry.mappedSellupRate,
          regularLastYearCurrentBookings: entry.regularLastYearCurrentBookings,
          regularLastYearFinalBookings: entry.regularLastYearFinalBookings,
          regularLastYearCurrentRevenue: entry.regularLastYearCurrentRevenue,
          regularLastYearFinalRevenue: entry.regularLastYearFinalRevenue,
          mappedLastYearCurrentBookings: entry.mappedLastYearCurrentBookings,
          mappedLastYearFinalBookings: entry.mappedLastYearFinalBookings,
          mappedLastYearCurrentRevenue: entry.mappedLastYearCurrentRevenue,
          mappedLastYearFinalRevenue: entry.mappedLastYearFinalRevenue,
          availability: entry.currentAvailability,
          mappedAvailability: entry.mappedCurrentAvailability,
          bidPrice: entry.bidPrice,
          details: entry.details,
          regularAggregateShare: entry.regularAggregateShare,
          userRegularAggregateShare: entry.userRegularAggregateShare,
          effectiveRegularAggregateShare: entry.effectiveRegularAggregateShare,
          mappedAggregateShare: entry.mappedAggregateShare,
          userMappedAggregateShare: entry.userMappedAggregateShare,
          effectiveMappedAggregateShare: entry.effectiveMappedAggregateShare,
          baseRegularRemainingDemandFC: entry.effectiveRegularBaseRemainingDemandFC,
          baseMappedRemainingDemandFC: entry.effectiveMappedBaseRemainingDemandFC,
          calculatedRegularRemainingDemandFC: entry.calculatedRegularRemainingDemandFC,
          calculatedMappedRemainingDemandFC: entry.calculatedMappedRemainingDemandFC,
          daysToDeparture: entry.daysToDeparture,
          startRtpRegularRemainingDemandFC: _.isNil(entry.startRtpRegularRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpRegularRemainingDemandFC,
          startRtpMappedRemainingDemandFC: _.isNil(entry.startRtpMappedRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpMappedRemainingDemandFC,
          departureDate: curYMD,
          departureDateMoment: momentDepartureDate,
          departureTimeMoment: memoizedGetTimeOfMoment(momentDepartureDate.value),
          departureDateMomentTimeOfDay: memoizedTimeOfDayOfMoment(momentDepartureDate.value),
          departureDateMomentDDD: curDOW,
          lastProcessedDateMoment: momentEventTimeStamp,
          appliedRules: entry.appliedRules,
          markRenormalize: undefined,
          associatedLegCabins: entry.associatedLegCabins,
          isForecastIgnored: entry.isForecastIgnored,
          isDiscontinued: entry.isDiscontinued ? 'Yes' : 'No',
          isManuallyControlled: isManuallyControlled,
          alerts: entry.alertScore,
          numberOfAlertRulesApplied: entry.numberOfAlertRulesApplied,
          alertThresholdExceeded: entry.alertScore > alertThreshold,
          eventTimeStamp: entry.eventTimeStamp,
          latestChanges: entry.latestChanges,
          appliedRulesNumber: entry.appliedRules.length,
          liveAvailability: entry.liveAvailability,
          liveTotalBkgs: entry.invResHoldTotal,
          liveIdvBkgs: entry.invResHoldIdv,
          liveGrpBkgs: entry.invResHoldGroup,
          mappedLiveAvailability: entry.mappedLiveAvailability,
          mappedLiveTotalBkgs: entry.mappedInvResHoldTotal,
          mappedLiveIdvBkgs: entry.mappedInvResHoldIdv,
          mappedLiveGrpBkgs: entry.mappedInvResHoldGroup,
          serviceClassAuthorizationModel: entry.authorizationModel,
          userRegularMinAuthorization: isAuthOverride ? entry.userRegularHardOverrideMinValue : null,
          userRegularMaxAuthorization: isAuthOverride ? entry.userRegularHardOverrideMaxValue : null,
          userRegularAuthLink: entry.userRegularLinkType === 'AUTH' ? entry.userRegularLinkValue : null,
          serviceClassAuthorizationAfterRules: entry.authorizationAfterRules,
          serviceClassSeatsAvailModel: entry.seatsAvailModel,
          userRegularMinAvailability: isAvailOverride ? entry.userRegularHardOverrideMinValue : null,
          userRegularMaxAvailability: isAvailOverride ? entry.userRegularHardOverrideMaxValue : null,
          userRegularAvailLink: entry.userRegularLinkType === 'AVAIL' ? entry.userRegularLinkValue : null,
          serviceClassSeatsAvailabilityAfterRules: entry.seatsAvailabilityAfterRules,
          regularIsBookingTrendCorrectionRequired: entry.regularIsBookingTrendCorrectionRequired,
          regularBookingTrendCorrectionFactor: entry.regularBookingTrendCorrectionFactor,
          mappedIsBookingTrendCorrectionRequired: entry.mappedIsBookingTrendCorrectionRequired,
          mappedBookingTrendCorrectionFactor: entry.mappedBookingTrendCorrectionFactor
        };
        bookingsIntakeTransformationService.calculateBookingsIntake(newEntry, entry);
        effectiveValueService.setDefaultTypes(newEntry);
        setEffectiveValues(newEntry, entry);
        result.push(newEntry);
      }
      return result;
    };
    return _.chain(data.domain.serviceClassPOS || data.domain.results).thru(function (serviceClassPOS) {
      // Initial Transformation
      return transformData(serviceClassPOS);
    }).thru(function (transformedData) {
      // Merge Scenario Data Stage
      var domain = data.thirdDomain || data.secondDomain;
      var scenarioData = transformData(domain && (domain.serviceClassPOS || domain.results) || []);
      return mergeScenarioDataService.merge(transformedData, scenarioData);
    }).thru(function (unNormalizedData) {
      // Normalization Data Stage
      if (renormalizeEffectiveValueService.shouldApplyRenormalization(unNormalizedData)) {
        return renormalizeEffectiveValueService.renormalizeAll(unNormalizedData);
      }
      return unNormalizedData;
    }).thru(function (normalizedData) {
      // Bookings Trend Correction
      return bookingsTrendCorrectionTransformationService.applyBTCFactor(normalizedData);
    }).value();
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getDOWOfMoment(moment) {
    return rmMomentFormat(moment, 'DAY_OF_WEEK');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return FlightServiceClassGridTransformer;
};
FlightServiceClassGridTransformerFactory.$inject = ['$filter', '$window', 'DataTransformerFactory', 'BookingsIntakeTransformationService', 'MergeScenarioDataService', 'CalculateEffectiveValueService', 'ConfigurationService', 'MomentService', 'HepService', 'FlightLiveDataService', 'ClassIndicesService', 'FcrService', 'BookingsTrendCorrectionTransformationService', 'RenormalizeEffectiveValueService'];
module.exports = FlightServiceClassGridTransformerFactory;